// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import ContentWithRouter from '@tcp/web/src/pages/content';
import { getDynamicLabelValues, renderLabel } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  StyledCategoryPromotionWrapper,
  StyledLongDescription,
  StyledSubHeadingWrapper,
  StyledSubHeading,
  StyledDetails,
  StyledModal,
} from '../styles/CategoryPromotion.style';

const categoryPromotionLabels = getDynamicLabelValues('dynamic.category_promotion');

const TnCModal = ({ openTnCModal, setOpenTnCModal, tncLink }) => {
  const toggleTnCModal = () => {
    setOpenTnCModal(false);
  };
  return (
    <StyledModal
      fixedWidth
      isOpen={openTnCModal}
      onRequestClose={toggleTnCModal}
      overlayClassName="TCPModal__Overlay"
      className={`category-promotion-tnc-modal`}
      maxWidth={`${window.innerWidth * 0.8}px`}
      maxHeight={`${window.innerHeight * 0.9}px`}
      minHeight={`${window.innerHeight * 0.9}px`}
      data-locator="category-promotion-tnc-modal"
      ariaLabelledby="category promotion tnc modal"
      ariaDescribedby="category promotion tnc modal"
    >
      <ContentWithRouter urlPath={tncLink} />
    </StyledModal>
  );
};

TnCModal.propTypes = {
  openTnCModal: PropTypes.bool.isRequired,
  setOpenTnCModal: PropTypes.func.isRequired,
  tncLink: PropTypes.string.isRequired,
};

const LONG_DESCRIPTION_LABEL = 'lbl_long_description';
const SUB_HEADER_LABEL = 'lbl_sub_header';
const DETAILS_LABEL = 'lbl_details';
const TNC_LABEL = 'lbl_tnc';

const getLabelValues = (categoryId) => {
  const transformedKey = categoryId?.replace(/ /g, '');
  const longDescriptionKey = `${LONG_DESCRIPTION_LABEL}_${transformedKey}`;
  const subHeaderKey = `${SUB_HEADER_LABEL}_${transformedKey}`;
  const detailsKey = `${DETAILS_LABEL}_${transformedKey}`;
  const tncLinkKey = `${TNC_LABEL}_${transformedKey}`;
  return {
    longDescription: renderLabel(categoryPromotionLabels[longDescriptionKey], longDescriptionKey),
    subHeader: renderLabel(categoryPromotionLabels[subHeaderKey], subHeaderKey),
    details: renderLabel(categoryPromotionLabels[detailsKey], detailsKey),
    tncLink: renderLabel(categoryPromotionLabels[tncLinkKey], tncLinkKey),
  };
};

const CategoryPromotion = (props) => {
  const { categoryId } = props;
  const [openTnCModal, setOpenTnCModal] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();
    setOpenTnCModal(true);
  };
  const labelValues = getLabelValues(categoryId);
  const defaultSubHeader = renderLabel(
    categoryPromotionLabels.lbl_sub_header_default,
    'lbl_sub_header_default'
  );

  if (labelValues?.longDescription.includes(LONG_DESCRIPTION_LABEL)) return null;

  return (
    <StyledCategoryPromotionWrapper className={`category-promotion-${categoryId}`}>
      <StyledLongDescription
        fontSize={['fs24', 'fs24', 'fs32']}
        fontWeight="bold"
        fontFamily="secondary"
        color="blue.800"
        className="long-description"
      >
        {labelValues?.longDescription}
      </StyledLongDescription>
      <StyledSubHeadingWrapper className="sub-heading-wrapper">
        <StyledSubHeading
          fontSize={['fs14', 'fs14', 'fs16']}
          fontWeight="bold"
          fontFamily="secondary"
          className="sub-heading"
          color="gray.600"
        >
          {labelValues?.subHeader.includes(SUB_HEADER_LABEL)
            ? defaultSubHeader
            : labelValues?.subHeader}
        </StyledSubHeading>
        {!labelValues?.details.includes(DETAILS_LABEL) && (
          <StyledDetails
            fontSize={['fs14', 'fs14', 'fs16']}
            fontWeight="bold"
            fontFamily="secondary"
            className="details"
            color="gray.600"
            target="_modal"
            component="a"
            onClick={handleClick}
            title={labelValues?.details}
            alt={labelValues?.details}
          >
            {labelValues?.details}
          </StyledDetails>
        )}
      </StyledSubHeadingWrapper>
      {!labelValues?.tncLink.includes(TNC_LABEL) && openTnCModal && (
        <TnCModal
          openTnCModal={openTnCModal}
          setOpenTnCModal={setOpenTnCModal}
          tncLink={labelValues?.tncLink}
        />
      )}
    </StyledCategoryPromotionWrapper>
  );
};

CategoryPromotion.propTypes = {
  categoryId: PropTypes.string.isRequired,
};

export default CategoryPromotion;
export { CategoryPromotion as CategoryPromotionVanilla };
